import { FieldValues } from 'react-hook-form'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'
import {
  buildProgramServiceHeaders,
  validateApiParams,
} from '../utils/functions'
import { OcrSplitPayload } from '../types/ocr.types'

const ACTRIOS_BASE = `${API_END_POINT.CASE_AUTOMATION}v1/ocr-data`
const headers: Record<string, string> = {
  'Content-Type': 'application/json',
}

export const getTemplateByBatchId = async (
  batchId: string
  // page?: number | string
) => {
  const url = `${ACTRIOS_BASE}/layout?batch_uuid=${batchId}`
  return await axiosInstance.get(url, { headers })
}

export const getPagesByBatchId = async (batchId: string) => {
  const url = `${ACTRIOS_BASE}/pages?batch_uuid=${batchId}`
  return await axiosInstance.get(url, { headers })
}

export const getPageDataByPage = async (batchId: string, page: number) => {
  const url = `${ACTRIOS_BASE}/approved?batch_id=${batchId}&page_number=${page}`
  return await axiosInstance.get(url, { headers })
}

export const submitReviewPageData = async (
  batchId: string,
  page: number,
  data: FieldValues
) => {
  const url = `${ACTRIOS_BASE}/approved?batch_uuid=${batchId}&page=${page}`
  return await axiosInstance.post(url, data, { headers })
}

export const ocrSplitApi = async (payload: OcrSplitPayload) => {
  const url = `${API_END_POINT.CASE_AUTOMATION}v1/ocr-split`
  return await axiosInstance.post(url, payload, { headers })
}

export const permissionToProceedManually = async (
  communicationId: string,
  programId?: string,
  status?: string,
  ocrDisabled = true
) => {
  const endpoint = `${API_END_POINT.TEMPLATE}/v1/communications/${communicationId}/status?status=${status}&ocrDisabled=${ocrDisabled}`
  validateApiParams(
    { communicationId },
    {
      endpoint,
      method: 'PUT',
    }
  )
  return await axiosInstance.put(endpoint, undefined, {
    headers: {
      ...buildProgramServiceHeaders(programId),
    },
  })
}
